$(document).ready(function () {
    $(".overlay-update-password").hide()
    $("#form-update-password").on('submit', function (e) {
        e.preventDefault()
        let datas = $("#form-update-password").serializeArray();
        $(".overlay-update-password").show()
        sendData('/update-password',datas)
    })

    function sendData(route,data) {
        $.ajax({
            url: route,
            type: "POST",
            data: data,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                $(".overlay-update-password").hide()
                $(".preloader").removeClass("preloader_");
                $('#form-update-password').trigger("reset");
                alertSuccess(data.msg)

            },
            error: function (errors, xhr, status,) {
                $(".overlay-update-password").hide()
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    console.log(index,value)
                    $(".item-"+index).text(value);
                });
            }
        })
    }
})
